import Vue from 'vue'
import http from '@/utils/ajax'
import { VEHICLE_INIT_LOADING, VEHICLE_INIT_SUCCESS, VEHICLE_INIT_FAIL, VEHICLE_PERMITSTATUSLIST, VEHICLE_BODYTYELIST, VEHICLE_MAKELIST, VEHICLE_GROUPLIST } from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'

const state = {
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  // API menu
  menu: {},
  permitStatus: [],
  makeList: [],
  bodyTypeList: []
}

const getters = {

}

const mutations = {
  [VEHICLE_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [VEHICLE_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [VEHICLE_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  },
  [VEHICLE_PERMITSTATUSLIST](state, data) {
    Vue.set(state, 'permitStatus', data)
  },
  [VEHICLE_BODYTYELIST](state, data) {
    Vue.set(state, 'bodyTypeList', data)
  },
  [VEHICLE_MAKELIST](state, data) {
    Vue.set(state, 'makeList', data)
  },
  [VEHICLE_GROUPLIST](state, data) {
    Vue.set(state, 'groupList', data)
  }
}

const actions = {
  async vehicleManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.vehManagement
    commit(VEHICLE_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      let apiURL = commitResult.menu.bodyTypeList
      if (apiURL) {
        try {
          const result = await http.get(apiURL)
          commit(VEHICLE_BODYTYELIST, result.data.data.bodyTypeList)
        } catch (err) {
          throw err
        }
      }
      apiURL = commitResult.menu.makeList
      if (apiURL) {
        try {
          const result = await http.get(apiURL)
          commit(VEHICLE_MAKELIST, result.data.data.makeList)
        } catch (err) {
          throw err
        }
      }
      apiURL = commitResult.menu.groupList
      if (apiURL) {
        try {
          const result = await http.get(apiURL)
          commit(VEHICLE_GROUPLIST, result.data.data.groupList)
        } catch (err) {
          throw err
        }
      }
      apiURL = commitResult.menu.permitStatusList
      if (apiURL) {
        try {
          const result = await http.get(apiURL)
          commit(VEHICLE_PERMITSTATUSLIST, result.data.data.PermitStatusList)
        } catch (err) {
          throw err
        }
      }
      commit(VEHICLE_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(VEHICLE_INIT_FAIL, extractMessages(error))
    }
  }
}
export default {
  state,
  getters,
  mutations,
  actions
}
